<template>
  <div class="content">
    <div class="ct">
      <div class="ct_head">
        <div class="ct_head_left">
          <span class="ct_head_left_biaoti">剩余时间&nbsp;</span>
          <span class="ct_head_left_shi">{{shijian.shi}}</span>&nbsp;:
          <span class="ct_head_left_fen">{{shijian.fen}}</span>&nbsp;:
          <span class="ct_head_left_miao">{{shijian.miao}}</span>
        </div>
       <div class="ct_head_right">
         <button v-if="cur_flag+1<Lenquestions" ref="nextClick" v-on:click="next_question" class="ct_head_right_btn">下一题</button>
          <button v-if="cur_flag+1>=Lenquestions"  v-on:click.once="testCommit" ref="proxyClick" class="ct_head_right_commit">结束考试</button>
        </div>
      </div>
      <div class="ct_body">
        <div class="ct_body_head">
          <div class="ct_body_head_left">
            <img class="ct_body_head_left_img" src="../assets/imgs/split.jpg" />&nbsp;
            <strong class="ct_body_head_left_mingchen">
              {{questions[cur_flag] ? questions[cur_flag].question.qType : ''}}
            </strong>
          </div>
          <div class="ct_body_head_right">
            <strong class="ct_body_head_right_cur">{{cur_flag+1}}</strong>/<span class="ct_body_head_right_zfs">{{totalCount}}</span>
          </div>
        </div>
        <div class="ct_body_neirong">
          <div class="ct_body_neirong_timu">
            <mt-radio v-if="questions[cur_flag] ? questions[cur_flag].question.qType == '判断题' : false" class='ct_body_neirong_timu_title'
              :title="questions[cur_flag] ? questions[cur_flag].question.qName : ''" v-model="radioValue"
              :options="questions[cur_flag] ? questions[cur_flag].answer : []">
            </mt-radio>
            <mt-radio v-else-if="questions[cur_flag] ? questions[cur_flag].question.qType == '单选题' : false" class='ct_body_neirong_timu_title'
              :title="questions[cur_flag] ? questions[cur_flag].question.qName : ''" v-model="radioValue"
              :options="questions[cur_flag] ? questions[cur_flag].answer : []">
            </mt-radio>
             <!-- v-model="radioValue" v-model="checkValue" -->
            <mt-checklist v-else-if="questions[cur_flag] ? questions[cur_flag].question.qType == '多选题' : false" class='ct_body_neirong_timu_title'
              :title="questions[cur_flag] ? questions[cur_flag].question.qName : ''" v-model="checkValue"
              :options="questions[cur_flag] ? questions[cur_flag].answer : []">
            </mt-checklist>
            <mt-checklist v-else-if="questions[cur_flag] ? questions[cur_flag].question.qType == '多选题' : false" class='ct_body_neirong_timu_title'
              title="填空题"  v-model="checkValue" :options="[{label: '填空题' ,value: '填空题'}]">
            </mt-checklist>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getJson } from '@/assets/js/httpjson.js'
import { post, fetchUrl } from '@/assets/js/network.js'
import Vue from 'vue'
import { Toast, Cell, Radio, Checklist, MessageBox } from 'mint-ui'
Vue.component(Cell.name, Cell)
Vue.component(Radio.name, Radio)
Vue.component(Checklist.name, Checklist)
export default {
  name: 'Question',
  data () {
    return {
      questionsList: [],
      referenceAnswersList: [],
      cur_flag: 0,
      totalCount: 0,
      radioValue: '',
      checkValue: [],
      shijian: { shi: '', fen: '', miao: '' },
      userAnswers: [],
      userErrorAnswers: [],
      questions: [],
      next_flag: true,
      commit_flag: false,
      UserPaper: {},
      commit_datas: false,
      userCount: 0,
      vartt: null
    }
  },
  mounted () {
    if (!this.$store.state.loginUser) {
      this.$router.replace('/')
      return
    }
    this.loadData()
    this.$nextTick(function () {
      this.daojishi(this.$store.state.pr.paperZsj * 60)
      this.init_question()
    })
  },
  computed: {
    Lenquestions () {
      return this.questions.length
    }
  },
  watch: {
    questions () {
      return this.questions.length
    }
  },
  methods: {
    createQuestionData (url, paperId, userId, cl) {
      let p = new Promise(function (resolve, reject) {
        let dataList = new Map()
        dataList.set('paperId', paperId)
        dataList.set('userId', userId)
        var map = getJson(url, cl._mapToJson(dataList))
        resolve(JSON.parse(map))
      })
      return p
    },
    async loadData () {
      let dataList = new Map()
      dataList.set('paperId', this.$store.state.pr.paperId)
      dataList.set('userId', this.$store.state.user.id)
      var _this = this
      post(fetchUrl('/api/newexamination/getQuestions'), {'paperId': this.$store.state.pr.paperId, 'userId': this.$store.state.user.id}, function (responseCode, message) {
        if (responseCode === 0 && message.length !== 0) {
          const datas = JSON.parse(message)
          // console.log(datas)
          if (datas.success && datas.Code === 1) {
            Toast(datas.data)
            _this.$router.replace('/list')
          } else {
            if (datas.success && datas.data.questionsList.length > 0) {
              _this.questionsList = datas.data.questionsList
              _this.totalCount = datas.data.questionsList.length
              _this.referenceAnswersList = datas.data.referenceAnswersList
              _this.UserPaper = datas.data.UserPaper
              _this.convertQuestions()
            } else {
              Toast('获取考试选项信息失败，请联系管理员。')
              _this.$router.replace('/list')
            }
          }
        } else {
          Toast('获取考试选项信息失败，请联系管理员。')
          _this.$router.replace('/list')
        }
      })
    },
    testCommit () {
      this.next_flag = false
      this.commit_flag = false
      window.clearTimeout(this.vartt)
      this.insertData(this.cur_flag)
      this.realCommit()
    },
    realCommit () {
      var _this = this
      post(fetchUrl('/api/newexamination/SubmitPapers'), {'userPaperId': this.UserPaper.userPaperId, 'Questions': this.userAnswers}, function (responseCode, message) {
        _this.userErrorAnswers = []
        if (responseCode === 0 && message.length !== 0) {
          const datas = JSON.parse(message)
          if (datas.success) {
            for (var i = 0; i < _this.questions.length; i++) {
              for (var j = 0; j < _this.userAnswers.length; j++) {
                if (_this.userAnswers[j].questionsId === _this.questions[i].question.qId && _this.userAnswers[j].answersNr === _this.questions[i].question.qBZTA) {
                  _this.userCount++
                }
                if (_this.userAnswers[j].questionsId === _this.questions[i].question.qId && _this.userAnswers[j].answersNr !== _this.questions[i].question.qBZTA) {
                  let qOption = _this.userAnswers[j].answersNr.split(',')
                  let qAnswerOption = []
                  for (let k = 0; k < _this.questions[i].answer.length; k++) {
                    for (let h = 0; h < qOption.length; h++) {
                      if (_this.questions[i].answer[k].value === qOption[h]) {
                        qAnswerOption.push({label: _this.questions[i].answer[k].label, optionValue: _this.questions[i].answer[k].value})
                      }
                    }
                  }
                  _this.userErrorAnswers.push({question: _this.questions[i].question, errAnswer: qAnswerOption})
                }
              }
            }
            var userInfo = {paperNr: _this.$store.state.pr.paperNr, questionsCount: _this.questions.length, wrongCount: _this.questions.length - _this.userCount, User_Paper_ZF: datas.data[0].User_Paper_ZF, User_Paper_yongshi: _this.yongshi(datas.data[0].User_Paper_KSSJ, datas.data[0].User_Paper_JSSJ)}
            _this.$store.commit('userInfoChange', userInfo)
            _this.$store.commit('userErrorAnswersChange', _this.userErrorAnswers)
            _this.userAnswers = []
            _this.$router.replace('/fh')
          } else {
            MessageBox.confirm('', {message: '试卷提交失败！', title: '错误提示1', cancelButtonText: '返回试卷列表', closeOnClickModal: false, confirmButtonText: '继续提交试卷'})
              .then(function () {
                _this.realCommit()
              }, function () {
                this.$router.replace('/list')
              })
          }
        } else {
          Toast({message: '提交考试失败!'})
        }
      })
    },
    yongshi: function (p1, p2) {
      const date1 = new Date(p1)
      const date2 = new Date(p2)
      const s1 = date1.getTime()
      const s2 = date2.getTime()
      const Minute2 = Number((s2 - s1) / 60000).toString()
      const Minute3 = Minute2.substring(0, Minute2.lastIndexOf('.')) <= 0 ? 1 : Minute2.substring(0, Minute2.lastIndexOf('.'))
      return Minute3
    },
    next_question () {
      this.insertData(this.cur_flag)
      this.cur_flag = this.cur_flag + 1
      this.$nextTick(function () {
        this.init_question()
      })
    },
    init_question () {
      if (this.cur_flag + 1 >= this.totalCount) {
        this.next_flag = false
        this.commit_flag = true
      }
    },
    convertQuestions () {
      var pId = this.$store.state.pr.paperId
      if (this.questionsList.length > 0) {
        this.questionsList.forEach((item, index) => {
          if (pId === item.Paper_ID) {
            var itemType = item.Questions_LX === 1 ? '判断题' : item.Questions_LX === 2 ? '填空题' : item.Questions_LX === 3 ? '单选题' : '多选题'
            var question = {qPaperId: pId, qId: item.Questions_ID, qName: item.Questions_NR, qTypeId: item.Questions_LX, qType: itemType, qFS: item.Questions_FS, qBZTA: item.Questions_BZTA, Questions_BZ: item.Questions_BZ}
            if (this.referenceAnswersList.length > 0) {
              var answers = []
              this.referenceAnswersList.forEach((itemAnswer, index) => {
                if (itemAnswer.Questions_ID === item.Questions_ID) {
                  var answer = {value: itemAnswer.ReferenceAnswers_ID.toString(), label: itemAnswer.ReferenceAnswers_NR}
                  answers.push(answer)
                }
              })
            }
            this.questions.push({question: question, answer: answers})
          }
        })
      }
    },
    insertData: function (idx) {
      if (this.questions[idx].question.qTypeId === 1 || this.questions[idx].question.qTypeId === 3) {
        this.userAnswers.push({ 'Paper_ID': this.questions[idx].question.qPaperId, 'questionsId': this.questions[idx].question.qId, 'answersNr': this.radioValue.toString() })
        this.radioValue = ''
      }
      if (this.questions[idx].question.qTypeId === 4) {
        this.userAnswers.push({ 'Paper_ID': this.questions[idx].question.qPaperId, 'questionsId': this.questions[idx].question.qId, 'answersNr': this.checkValue.sort().join(',') })
        this.checkValue = []
      }
    },
    filling: function (a) {
      if (a.toString().length <= 1) {
        return '0' + a
      } else {
        return a
      }
    },
    daojishi: function (counttime) {
      if (counttime >= 0) {
        var ms = counttime % 60
        var mis = Math.floor(counttime / 60)
        if (mis >= 60) {
          var hour = Math.floor(mis / 60)
          mis = Math.floor((counttime - hour * 60 * 60) / 60)
          this.shijian.shi = this.filling(hour)
          this.shijian.fen = this.filling(mis)
          this.shijian.miao = this.filling(ms)
        } else if (mis >= 1) {
          this.shijian.shi = '00'
          this.shijian.fen = this.filling(mis)
          this.shijian.miao = this.filling(ms)
        } else {
          this.shijian.shi = '00'
          this.shijian.fen = '00'
          this.shijian.miao = this.filling(ms)
        }
        counttime--
        this.vartt = window.setTimeout(this.daojishi, 1000, counttime)
      } else {
        this.$nextTick(function () {
          this.testCommit()
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .content
    position: absolute
    width: 100%
    height: 100%
    left: 0
    top: 0
    right: 0
    bottom: 0
    background: #00bcd4
    font-size: .35rem
    .ct
      margin-top: .6rem
      padding: 0 .2rem
      .ct_head
        display: flex
        height: .6rem
        line-height: .6rem
        background: #f6f6f6
        border-radius: .06rem .06rem 0 0
        padding: .1rem .2rem
        border-bottom: 1px solid lightgrey
        .ct_head_left
          flex: 1
          .ct_head_left_shi
            background: black
            color: white;
            padding-left: .1rem
            padding-right: .1rem
            border-radius: .08rem
          .ct_head_left_fen
            background: black
            color: white;
            padding-left: .1rem
            padding-right: .1rem
            border-radius: .08rem
          .ct_head_left_miao
            background: black
            color: white;
            padding-left: .1rem
            padding-right: .1rem
            border-radius: .08rem
        .ct_head_right
          .ct_head_right_btn
            background: #AC2925
            padding: .03rem
            padding-left: .2rem
            padding-right: .2rem
            border-radius: .1rem
            outline: none
            color: white;
          .ct_head_right_commit
            background: #AC2925
            padding: .03rem
            padding-left: .2rem
            padding-right: .2rem
            border-radius: .1rem
            outline: none
            color: white
      .ct_body
        background: white
        padding: .2rem .2rem 0 .2rem
        border-radius: 0 0 .06rem .06rem
        .ct_body_head
          display: flex;
          padding-bottom: .1rem
          box-sizing: border-box;
          border-bottom: 1px solid #f1f0f0
          .ct_body_head_left
            display: flex
            align-items: center
            flex: 1
            .ct_body_head_left_mingchen
              text-align: justify
              font-weight: bold
          .ct_body_head_right
            padding-right: .2rem
            .ct_body_head_right_cur
              font-weight: bold
        .ct_body_neirong
          padding-top: .3rem
          .ct_body_neirong_timu
            .ct_body_neirong_timu_title >>> .mint-radiolist-title
              font-size: .35rem
              color: black
              line-height: .5rem
            .ct_body_neirong_timu_title >>> .mint-checklist-title
              font-size: .35rem
              color: black
              line-height: .5rem
</style>



// WEBPACK FOOTER //
// src/question/Question.vue